export const getSelectionTitleTeaserProps = (selection) => {
    return {
        name: selection.selectionDisplayName
    };
};
//# sourceMappingURL=getSelectionTitleTeaserProps.js.map